"use client";

import { Card } from "react-bootstrap";
import { getRankImage } from "../../../utils/getRankImage";
import { getRankColor } from "../../../utils/getRankColor";

interface MaxRank {
  period?: { start?: string; end?: string };
  user_data?: {
    total_points?: number;
    rank?: { name?: string };
  };
}

// timeZone UTC a proposito: la fecha llega como ISO a medianoche UTC y sin
// esto un huso negativo (Bogota, UTC-5) devolveria el mes anterior.
const formatMonth = (value?: string) => {
  if (!value) return null;

  const month = new Date(value).toLocaleDateString("es-CO", {
    month: "long",
    timeZone: "UTC",
  });

  return month.charAt(0).toUpperCase() + month.slice(1);
};

const MaxRankCard = ({ maxRank }: { maxRank?: MaxRank }) => {
  const rankName = maxRank?.user_data?.rank?.name;

  // Sin historial de rangos no hay insignia que mostrar.
  if (!maxRank || !rankName) return null;

  const color = getRankColor(rankName);
  const period = formatMonth(maxRank.period?.start ?? maxRank.period?.end);

  return (
    <Card
      className="border-0 rounded-4 p-4 mb-4 text-center"
      style={{ background: "#0d1117", color: "#fff" }}
    >
      <div
        className="mx-auto rounded-circle d-flex align-items-center justify-content-center mb-3"
        style={{
          // clamp: la tarjeta vive en una columna lg=3 (~280px) y a ancho
          // completo en movil, asi que la insignia escala con el contenedor.
          width: "clamp(110px, 55%, 180px)",
          aspectRatio: "1",
          background: `radial-gradient(circle, ${color}33 0%, transparent 70%)`,
        }}
      >
        <img
          src={getRankImage(rankName)}
          alt={rankName}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            filter: `drop-shadow(0 0 14px ${color})`,
          }}
        />
      </div>

      <h2
        className="fw-bold mb-2 text-break"
        style={{ color, fontSize: "clamp(24px, 6vw, 40px)", lineHeight: 1.1 }}
      >
        {rankName}
      </h2>

      <div>
        <span
          className="d-inline-block px-3 py-1 rounded-pill fw-semibold"
          style={{
            background: `${color}26`,
            border: `1px solid ${color}59`,
            fontSize: 13,
          }}
        >
          Rango máximo alcanzado
        </span>
      </div>

      <div
        className="d-flex flex-wrap justify-content-between align-items-center gap-2 mt-4 pt-3"
        style={{ borderTop: "1px solid rgba(255,255,255,.08)" }}
      >
        <div className="d-flex align-items-center text-start">
          <i className="ri-star-smile-fill me-2" style={{ color, fontSize: 20 }} />
          <span className="text-secondary">Puntos al alcanzarlo:</span>
        </div>

        <strong style={{ fontSize: 18 }}>
          {(maxRank.user_data?.total_points ?? 0).toLocaleString()}
        </strong>
      </div>

      {period && (
        <div
          className="d-flex align-items-center text-start gap-2 mt-3 pt-3"
          style={{ borderTop: "1px solid rgba(255,255,255,.08)" }}
        >
          <i className="ri-calendar-line" style={{ color, fontSize: 20 }} />

          <div>
            <div className="text-secondary">Fecha de rango:</div>
            <strong className="text-break">{period}</strong>
          </div>
        </div>
      )}
    </Card>
  );
};

export default MaxRankCard;
